import { ISegmentOffer, ITDSOfferRawData } from './type';

export const hydrateFormData = (data: ISegmentOffer): ITDSOfferRawData => {
	const hydratedData: ITDSOfferRawData = {} as ITDSOfferRawData;
	hydratedData.segmentName = data.segmentName;
	hydratedData.exclSegmentList = data.exclSegmentList.join(',') || '';
	hydratedData.cashbackRewardPer = data.cashbackRewardPer;
	hydratedData.isActive = data.isActive;
	return hydratedData;
};

export const dehydrateFormData = (data: ITDSOfferRawData): ISegmentOffer => {
	const tdsOffer: ISegmentOffer = {} as ISegmentOffer;
	tdsOffer.segmentName = data.segmentName;
	tdsOffer.isActive = data.isActive;
	tdsOffer.cashbackRewardPer = data.cashbackRewardPer;
	tdsOffer.exclSegmentList = data?.exclSegmentList ? data?.exclSegmentList.split(',') : [];
	return tdsOffer;
};
